module.exports = __webpack_public_path__ + "public/images/slider/peremutov-circle.3a92b3bce340589f07c67b7044ef48fa.png";